import React from "react";

const typeOptions = [
    {id: 'leaf', value: 'leaf', label: 'LEAF'},
    {id: 'branch', value: 'branch', label: 'BRANCH'},
    {id: 'root', value: 'root', label: 'ROOT'}
]

export const typeFiltersMapProvider = {
    getOptions,
    getItem,
};

async function getOptions(){
    try {


        return typeOptions.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.id,
                    label: <div><label>{item.label}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error);
    }
}

async function getItem(id){
    try {
        const item = {}
        return (
            {
                id: item.id,
                value: item.code + " - " + item.name,
                label: <div><label>{item.code + " - " + item.name}</label></div>
            }
        );
    } catch (error) {
        console.log(error);
    }
}